import { Fragment, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RouteComponentProps } from "../../models/RouteComponent";
import { TabView, TabPanel } from 'primereact/tabview';
import { consultantUpdate } from "../../service/consultantService";
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Grid } from "@mui/material";
import { FormControl, FormLabel } from "@mui/joy";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputSwitch } from 'primereact/inputswitch';
import AccessLevelTree from "../../components/AccessLevelTree";
import { accessLevelAdd, accessLevelUpdate } from "../../service/accessLevelService";
import { Form, FormBuilder } from "dsf-form-builder";
import { getAll } from "../../service/employeeService";
import "dsf-form-builder/dist/style.css"
import { addForm, submitForm, updateForm } from "../../service/formService";

export default function FormsView(props: RouteComponentProps) {

  const navigate = useNavigate();

  const formRecord = props.form;

  console.log("formRecord == ", formRecord);

  const accessLevel = props.accessLevel;

  const clientID = props.session.client_id;

  const [form, setForm] = useState<any>({ ...formRecord?.form, ...{ id: formRecord?.id } });

  console.log("formRecord?.form == ", formRecord?.form);

  const [formConfig, setFormConfig] = useState<any>()

  const toast = useRef(null as any);

  const record_id = formRecord?.id;

  async function updateAccessLevel(event: any) {
    console.log("event == ", event);
    setFormConfig(event);
  }

  let config = props.form?.config || {
    external_select_options: [
      {
        key: "employees",
        label: "Site Employees",
        options_func: async () => {
          return (await getAll()).map((item: any) => {
            return {
              value: item, label: item.full_name
            }
          }
          )
        }
      }
    ]
  };

  async function saveForm() {

    let UpdateConfig = {
      client: clientID,
      form: formConfig,
      config
    }

    props.setGlobalLoader(true);
    submitForm(UpdateConfig).then((r: any) => {
      toast.current.show({ severity: 'success', summary: 'Form Submitted Successfully', life: 3000 });
      props.setGlobalLoader(false);
      navigate('/form-table');
    }).catch((err) => {
      toast.current.show({ severity: 'error', summary: 'Form Submission Failed', life: 3000 });
      props.setGlobalLoader(false);
    })
  }

  console.log("config == ", config);

  return (
    <Fragment>
      <Form form={form} onChange={updateAccessLevel} config={formRecord?.config || config} />
      <Button type="button" icon="pi pi-arrow-up" label="Submit" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 70, top: 75, color: "#2dd36f" }} onClick={() => saveForm()} />

      <Toast ref={toast} />
    </Fragment>
  );
}